import { ADMIN_DASHBOARD_PAGE_INPUT_CLASS } from "./adminControlContracts";

type AdminPaginationControlProps = {
  page: number;
  totalPages: number;
  onPageChange: (nextPage: number) => void;
  label?: string;
  className?: string;
};

// Keeping tables aligned through one pagination widget ensures spacing and page wiring stay consistent across dashboards. (DL-002, DL-003)
export function AdminPaginationControl({
  page,
  totalPages,
  onPageChange,
  label = "Page",
  className = "",
}: AdminPaginationControlProps) {
  const resolvedTotalPages = Math.max(totalPages, 1);
  const toSafePage = (rawValue: string) => {
    const parsedPage = Number.parseInt(rawValue, 10);
    if (!Number.isFinite(parsedPage)) {
      return 1;
    }

    return Math.min(Math.max(parsedPage, 1), resolvedTotalPages);
  };

  return (
    <div
      className={`flex items-center gap-2 whitespace-nowrap ${className}`.trim()}
    >
      <span className="text-black dark:text-white">{label}</span>
      <input
        type="number"
        value={page}
        min={1}
        max={resolvedTotalPages}
        onChange={(event) =>
          onPageChange(toSafePage(event.currentTarget.value))
        }
        className={ADMIN_DASHBOARD_PAGE_INPUT_CLASS}
      />
      <span className="text-black dark:text-white">/ {resolvedTotalPages}</span>
    </div>
  );
}
